var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploading2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.56,
    height: 14.56,
    viewBox: "0 0 14.56 14.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M14.56 14.56H0V0h14.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    id: "upload_path_2",
    d: "M12.74 3.033H1.82V1.82h10.92zM6.673 9.1H2.426L7.28 4.246 12.133 9.1H7.887v4.853H6.673z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploading2);
export default __webpack_public_path__ + "static/media/uploading2.69fefb4746934f02e65fbb35b7bd689b.svg";
export { ForwardRef as ReactComponent };